// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* components/common/SearchableCountryDropdown.css */
.country-dropdown-container {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  position: relative;
  margin: 12px 0;
}

.country-dropdown-trigger {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  border: none;
  box-shadow: rgb(40 40 40 / 35%) 0px 5px 15px;
  padding: 12px;
  border-radius: 8px;
  text-align: center;
  height: 6vh;
  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);
  background-color: white;
  cursor: pointer;
  /* Update display and alignment properties */
  display: flex;
  justify-content: center; /* Centers the content horizontally */
  align-items: center;    /* Centers the content vertically */
  position: relative;     /* For positioning the arrow */
}

.country-dropdown-content {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background-color: white;
  border-radius: 8px;
  box-shadow: rgb(40 40 40 / 35%) 0px 5px 15px;
  margin-top: 4px;
  z-index: 1000;
}

.country-search-input {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  border: none;
  padding: 12px;
  text-align: center;
  border-radius: 8px 8px 0 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.country-search-input:focus {
  outline: none;
  box-shadow: 0 0 2px 2px #4CAF50;
}

.country-list {
  max-height: 300px;
  overflow-y: auto;
}

.country-item {
  padding: 12px;
  cursor: pointer;
  text-align: center;
  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);
}

.country-item:hover,
.country-item.highlighted {
  background-color: var(--theme-consistent);
  color: white;
}

.country-dropdown-arrow {
  position: absolute;
  right: 12px;           /* Position arrow on the right */
}

.no-results {
  padding: 12px;
  text-align: center;
  color: var(--text-primary);
}

@media (max-width: 768px) {
  .country-dropdown-trigger,
  .country-search-input {
    font-size: 16px;
    padding: 8px;
    height: auto;
    min-height: 44px;
  }

  .country-list {
    max-height: 250px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/SearchableCountryDropdown.css"],"names":[],"mappings":"AAAA,oDAAoD;AACpD;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,4CAA4C;EAC5C,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,2CAA2C;EAC3C,uBAAuB;EACvB,eAAe;EACf,4CAA4C;EAC5C,aAAa;EACb,uBAAuB,EAAE,qCAAqC;EAC9D,mBAAmB,KAAK,mCAAmC;EAC3D,kBAAkB,MAAM,8BAA8B;AACxD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,4CAA4C;EAC5C,eAAe;EACf,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,0BAA0B;EAC1B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;;EAEE,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW,YAAY,gCAAgC;AACzD;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE;;IAEE,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* components/common/SearchableCountryDropdown.css */\n.country-dropdown-container {\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  position: relative;\n  margin: 12px 0;\n}\n\n.country-dropdown-trigger {\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  border: none;\n  box-shadow: rgb(40 40 40 / 35%) 0px 5px 15px;\n  padding: 12px;\n  border-radius: 8px;\n  text-align: center;\n  height: 6vh;\n  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);\n  background-color: white;\n  cursor: pointer;\n  /* Update display and alignment properties */\n  display: flex;\n  justify-content: center; /* Centers the content horizontally */\n  align-items: center;    /* Centers the content vertically */\n  position: relative;     /* For positioning the arrow */\n}\n\n.country-dropdown-content {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: rgb(40 40 40 / 35%) 0px 5px 15px;\n  margin-top: 4px;\n  z-index: 1000;\n}\n\n.country-search-input {\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  border: none;\n  padding: 12px;\n  text-align: center;\n  border-radius: 8px 8px 0 0;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.country-search-input:focus {\n  outline: none;\n  box-shadow: 0 0 2px 2px #4CAF50;\n}\n\n.country-list {\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.country-item {\n  padding: 12px;\n  cursor: pointer;\n  text-align: center;\n  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);\n}\n\n.country-item:hover,\n.country-item.highlighted {\n  background-color: var(--theme-consistent);\n  color: white;\n}\n\n.country-dropdown-arrow {\n  position: absolute;\n  right: 12px;           /* Position arrow on the right */\n}\n\n.no-results {\n  padding: 12px;\n  text-align: center;\n  color: var(--text-primary);\n}\n\n@media (max-width: 768px) {\n  .country-dropdown-trigger,\n  .country-search-input {\n    font-size: 16px;\n    padding: 8px;\n    height: auto;\n    min-height: 44px;\n  }\n\n  .country-list {\n    max-height: 250px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
